module.exports = __webpack_public_path__ + "img/fira-code-dark.f3819f25.png";